var _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.087,
    cy: 16.9598,
    rx: 16.087,
    ry: 16.0908,
    fill: "#E32142"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.41304,
    cy: 3.28263,
    rx: 2.41304,
    ry: 2.41361,
    fill: "#E32142"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6663 23C30.6663 21.7113 29.4724 20.6666 27.9997 20.6666C26.5269 20.6666 25.333 21.7113 25.333 23C25.333 24.2886 26.5269 25.3333 27.9997 25.3333C29.4724 25.3333 30.6663 26.378 30.6663 27.6666C30.6663 28.9553 29.4724 30 27.9997 30C26.5269 30 25.333 28.9553 25.333 27.6666",
    stroke: "#E32142",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.6666V20.6666",
    stroke: "#E32142",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30V32",
    stroke: "#E32142",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9661 19.436C20.7828 16.986 23.0756 15.3334 25.6582 15.3334H30.3424C32.925 15.3334 35.2179 16.986 36.0345 19.436L38.7012 27.436C39.9963 31.3212 37.1044 35.3334 33.0091 35.3334H22.9915C18.8962 35.3334 16.0044 31.3212 17.2994 27.436L19.9661 19.436Z",
    stroke: "#E32142",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7815 15.3333L25.2191 15.3333L23.351 13.1906C21.5198 11.0901 23.6561 7.95059 26.3298 8.81309L27.5668 9.21215C27.8484 9.303 28.1522 9.303 28.4339 9.21215L29.6709 8.81309C32.3445 7.95059 34.4809 11.0901 32.6496 13.1906L30.7815 15.3333Z",
    stroke: "#E32142",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEarn);
export default __webpack_public_path__ + "static/media/total-earn.405bfefa8e8310a62f9ca45bfbcb09cb.svg";
export { ForwardRef as ReactComponent };